import React, { useState } from "react";
import {
  Button,
  DevNote,
  DropdownMenuNew,
  FormFieldSet,
  SmartTooltip,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import VideoInterviewAddAccountModal from "../../Modals/VideoInterviewModals/VideoInterviewAddAccountModal";
import VideoInterviewAddUsersModal from "../../Modals/VideoInterviewModals/VideoInterviewAddUsersModal";

const Configure = ({category, type, selectedModule}) => {
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showAddUsersModal, setShowAddUsersModal] = useState(false);

  const rows = [
    {
      DisplayName: "Zoom Account 1",
      NoOfUsers: 1,
    },
    {
      DisplayName: "Zoom Account 2",
      NoOfUsers: 2,
    },
    {
      DisplayName: "Zoom Account 3",
      NoOfUsers: 1,
    },
    {
      DisplayName: "Zoom Account 4",
      NoOfUsers: 1,
    },
    {
      DisplayName: "Zoom Account 5",
      NoOfUsers: 1,
    },
    {
      DisplayName: "Zoom Account 6",
      NoOfUsers: 1,
    },
    {
      DisplayName: "Zoom Account 7",
      NoOfUsers: 1,
    },
  ];

  const columns = [
    {
      key: "",
      label: "",
      width: 150,
      render: (row) => (
        <div className="flex gap-4 items-center">
          <DropdownMenuNew
            MenuSection={
              <div className="flex flex-col">
                <Button
                  title={"Add Users"}
                  icon={"group_add"}
                  variant="text"
                  color="black"
                  size="sm"
                  className="!justify-start py-1"
                  onClick={() => setShowAddUsersModal(true)}
                />

                <Button
                  title={"Edit"}
                  icon={"edit_square"}
                  variant="text"
                  color="black"
                  size="sm"
                  className="!justify-start py-1"
                />

                <Button
                  title={"Delete"}
                  icon={"delete"}
                  variant="text"
                  color="black"
                  size="sm"
                  className="!justify-start py-1"
                />
              </div>
            }
          >
            <Button
              type="icon"
              variant="text"
              icon={"more_vert"}
              color="black"
              label="true"
            />
          </DropdownMenuNew>
        </div>
      ),
    },
    {
      key: "DisplayName",
      label: "Display Name",
      minWidth: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.DisplayName}</div>
      ),
    },
    {
      key: "NoOfUsers",
      label: "No. Of Users",
      width: 250,
      render: (row) => (
        <div className="text-info cursor-pointer">{row.NoOfUsers}</div>
      ),
    },
    {
      key: "",
      label: "Status",
      width: 150,
      render: (row) => (
        <SmartTooltip description={"Toggle"} noicon>
          <Button
            type="icon"
            variant="text"
            icon="toggle_off"
            color="black"
            size="sm"
          />
        </SmartTooltip>
      ),
    },
  ];

  const mappedRows = mapTableRows(rows, columns);

  if (selectedModule === "bs") {
    return (
        <div className="mt-3">
          <p>This feature is not available for Bench Sales. However, you can configure the following features:</p>
          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Available Features for Bench Sales:</h6>
            <p>1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt; Kult AI (Text) &gt; Setup / Configure</p>
            <p>2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt; Apollo &gt; Setup / Configure</p>
            <p>3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt; G-Suite &gt; Setup / Configure</p>
            <p>4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt; Outlook &gt; Setup / Configure</p>
          </div>
        </div>
      );
  }

  return (
    <div className="mt-6 shadow-sm p-2 bg-white border border-gray-100 rounded">
      <DevNote>
          <div>
            Table data is currently dummy, so a loader is not implemented. Add Loader when real data is available.
          </div>
        </DevNote>
      <TableAdv
        tableId={`ats_marketplace_videointerviewtabs_${type}_table`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        toolbarRight={{
          search: true,
          fullScreen: true,
          add: [
            {
              component: (
                <Button
                  title={"Add Account"}
                  size="sm"
                  onClick={() => setShowAddAccountModal(true)}
                />
              ),
            },
          ],
        }}
      />
      <VideoInterviewAddUsersModal
        showAddUsersModal={showAddUsersModal}
        setShowAddUsersModal={setShowAddUsersModal}
      />
      <VideoInterviewAddAccountModal
        showAddAccountModal={showAddAccountModal}
        setShowAddAccountModal={setShowAddAccountModal}
      />
    </div>
  );
};

export default Configure;
